import React from 'react'
import Navbar from './Navbar'

export default function Books() {
     
  return (
    <div>
      <Navbar></Navbar>
      <div className='flex  items-center flex-wrap justify-center h-[730px] bg-gray-200 overflow-auto'>
      <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="rich.jpeg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Rich dad poor dad</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
        <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (1).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Mathematics</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (2).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Charlie and chocolate</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (3).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Three men in a boat</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (6).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>A Song of Ice and Fire</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (5).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>The story of my life</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download (4).jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Gullivers's Travels</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
    <div className='m-3 flex flex-col items-center bg-yellow-50 w-[300px] h-[400px] rounded-md border-2 border-black'>
      <div className='m-4'>
          <div>
            <img className="border-2 rounded-md border-black" src="download.jpg" alt="" />
         </div>
        
      </div>
      
      <div>
        <p className='text-xl'>Rd sharma</p>
      </div>
      <div className=" my-2 flex justify-around w-full text-white">
      <div className='flex items-center px-2 py-1 rounded-md bg-gray-900' >
          <img  className="w-5" src="icons8-cart-50 (1).png" alt="" />
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Add to cart</button>
        </div>
        <button className=' px-2 py-1 rounded-md bg-gray-900'>Buy</button>
      </div>
      
    
    </div>
   
    
    
  
    </div>
    
      
    </div>
  )
}
